(() => {
  const init = (root = document) => {
    root.querySelectorAll('[data-al-cinema]').forEach(section => {
      if (section.dataset.ready) return;
      section.dataset.ready = 'true';
      const video = section.querySelector('[data-al-video]');
      const button = section.querySelector('[data-al-toggle]');
      if (!video || !button) return;
      const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      let playlist = [];
      try { playlist = JSON.parse(section.querySelector('[data-al-playlist]')?.textContent || '[]').filter(Boolean); } catch (_) {}
      const fallback = video.querySelector('source[data-src]')?.dataset.src;
      if (fallback && !playlist.includes(fallback)) playlist.push(fallback);
      const selectedFilm = playlist[Math.floor(Math.random() * playlist.length)];
      let manualPause = false;
      let visible = true;
      let loaded = false;
      const update = () => {
        button.textContent = video.paused ? section.dataset.play + ' ▷' : section.dataset.pause + ' Ⅱ';
        button.setAttribute('aria-label', video.paused ? section.dataset.playLabel : section.dataset.pauseLabel);
      };
      const play = async () => {
        if (!loaded) {
          if (selectedFilm) video.src = selectedFilm;
          else video.querySelectorAll('source[data-src]').forEach(s => { s.src = s.dataset.src; });
          video.load(); loaded = true;
        }
        try { await video.play(); } catch (_) { update(); }
      };
      video.addEventListener('playing', () => { video.classList.add('is-playing'); update(); });
      video.addEventListener('pause', update);
      video.addEventListener('error', () => { video.classList.remove('is-playing'); button.hidden = true; });
      button.hidden = false;
      button.addEventListener('click', () => { if (video.paused) { manualPause = false; play(); } else { manualPause = true; video.pause(); } });
      const observer = new IntersectionObserver(entries => {
        visible = entries[0].isIntersecting;
        if (!visible) video.pause();
        else if (!manualPause && !motion.matches && !navigator.connection?.saveData && !document.hidden) play();
      }, { threshold: 0.15 });
      observer.observe(section);
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) video.pause();
        else if (visible && !manualPause && !motion.matches && !navigator.connection?.saveData) play();
      });
      motion.addEventListener('change', () => { if (motion.matches) video.pause(); });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
